import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { ApiKeys } from './pages/ApiKeys';
import { AddApiKey } from './pages/AddApiKey';
import { EditApiKey } from './pages/EditApiKey';
import { Licenses } from './pages/Licenses';
import { AddLicense } from './pages/AddLicense';
import { EditLicense } from './pages/EditLicense';
import { Users } from './pages/Users';
import { AddUser } from './pages/AddUser';
import { EditUser } from './pages/EditUser';
import { Apps } from './pages/Apps';
import { AddApp } from './pages/AddApp';
import { EditApp } from './pages/EditApp';
import { WithAuth } from './wrappers/WithAuth';
import { UIMatch } from 'react-router-dom';
import { AuditApps } from './pages/AuditApps';
import { AuditUsers } from './pages/AuditUsers';
import { LicenseLogs } from './pages/LicenseLogs';

// prettier-ignore
export const routes = [
    {path: '/', element: <Layout />, handle: {crumb: () => ({link: "/", title: "Home"})}, children: [
        {path:"/", element: <WithAuth><HomePage /></WithAuth> },
        {path:"/login", element: <LoginPage /> },

        // Application management
        {path:"/apps", handle: {crumb: () => ({link: "/apps", title: "Apps"})}, children: [
            {path:"/apps", element: <WithAuth><Apps /></WithAuth>},
            {path:"/apps/create", element: <WithAuth><AddApp /></WithAuth> },
            {path:"/apps/:shortCode", element: <WithAuth><EditApp /></WithAuth> },
        ] },

        // API Keys
        {path:"/api-keys", handle: {crumb: () => ({link: "/api-keys", title: "Api Keys"})}, children: [
            {path:"/api-keys", element: <WithAuth><ApiKeys /></WithAuth> },
            {path:"/api-keys/create", element: <WithAuth><AddApiKey /></WithAuth> },
            {path:"/api-keys/:keyId", handle: {crumb: ({params}: UIMatch) => ({link: `/api-keys/${encodeURIComponent(params.keyId ?? '')}`, title: params.keyId})}, children: [
                {path:"/api-keys/:keyId", element: <WithAuth><EditApiKey /></WithAuth>},
                // Licenses
                {path:"/api-keys/:keyId/licenses", handle: {crumb: ({params}: UIMatch) => ({link: `/api-keys/${encodeURIComponent(params.keyId ?? '')}/licenses`, title: "Licenses"})}, children: [
                    {path:"/api-keys/:keyId/licenses", element: <WithAuth><Licenses /></WithAuth>},
                    {path:"/api-keys/:keyId/licenses/create", element: <WithAuth><AddLicense /></WithAuth> },
                    {path:"/api-keys/:keyId/licenses/:licenseId", element: <WithAuth><EditLicense /></WithAuth> },
                ] },
            ] },
        ] },

        // User management
        {path:"/users", children: [
            {path:"/users", element: <WithAuth><Users /></WithAuth>},
            {path:"/users/create", element: <WithAuth><AddUser /></WithAuth> },
            {path:"/users/:id", element: <WithAuth><EditUser /></WithAuth> },
        ] },
        
        // Log routes
        {path:"/logs", children: [
            {path:"/logs/licenses", element: <WithAuth><LicenseLogs /></WithAuth>},
        ] },
        
        // Audit routes
        {path:"/audit", children: [
            {path:"/audit/apps", element: <WithAuth><AuditApps /></WithAuth>},
            {path:"/audit/users", element: <WithAuth><AuditUsers /></WithAuth> },
        ] },
    ]},
];
